import React from 'react';
import './AndroidAuthLayout.css';

// Native authentication has its own app chrome, without the website navigation.
export default function AndroidAuthLayout({ children }) {
  return <div className="android-auth-layout public-layout">
    <header className="android-auth-brand"><img src="/Logo.png" alt="" width="40" height="40" /><span>UpyaChat</span></header>
    <main>{children}</main>
  </div>;
}
